import React, { useState } from 'react'

const Contact = () => {
  const initialState = {
    name: "",
    email: "",
    company: "",
    message: ""
}
    const [formData, setFormData] = useState(initialState);

    const handeChange = (event) => {
      const {name, value, type, checked} = event.target;
      setFormData(prevFormData => {
        return {
          ...prevFormData,
          [name]: type === "checkbox" ? checked : value
        }
      });
    }

    const handleSubmit = async(event) => {
      event.preventDefault();
      try {
        const res = await fetch("https://formspree.io/f/moqrygog",{
          method: "POST",
          headers: {
            'Accept': 'application/json'
        },
          body: JSON.stringify(formData)
        });

        if(res.ok){
          alert("message sent successfully!")
        }
      } catch (error) {
        console.error(error)
        alert("Oops! There was a problem submitting your form")
      } finally {
        setFormData(initialState)
      }
  }
    return(
    <div className="px-6 py-24 sm:py-32 lg:px-8 bg-black bg-gradient-to-tl from-zinc-900 via-zinc-400/10 to-zinc-900" id="contact">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="text-3xl font-bold tracking-tight text-indigo-500 sm:text-4xl">Get a qoute from our experts</h2>
        <p className="mt-2 text-lg leading-8 text-gray-600">
          How can we help?
        </p>
        <p className="mt-2 text-lg leading-8 text-gray-600">
          Fill out the form below and we will be in touch
        </p>
      </div>
      <form onSubmit={handleSubmit} className="mx-auto mt-16 max-w-xl sm:mt-20">
        <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
          <div className="sm:col-span-2">
            <label htmlFor="first-name" className="block text-sm font-semibold leading-6 text-zinc-400">
              Full name
            </label>
            <div className="mt-2.5">
              <input
                type="text"
                name="name"
                id="name"
                autoComplete="given-name"
                placeholder="Your full name"
                required
                className="block w-full rounded-md border-0 px-3.5 py-2 shadow-sm ring-1 ring-inset bg-transparent ring-indigo-300 placeholder:text-zinc-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                value={formData.name}
                onChange={handeChange}
              />
            </div>
          </div>
          <div className="sm:col-span-2">
            <label htmlFor="company" className="block text-sm font-semibold leading-6 text-zinc-400">
              Company
            </label>
            <div className="mt-2.5">
              <input
                type="text"
                name="company"
                id="company"
                autoComplete="organization"
                placeholder="Your compamy name"
                required
                className="block w-full rounded-md border-0 px-3.5 py-2 shadow-sm ring-1 ring-inset bg-transparent ring-indigo-300 placeholder:text-zinc-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                value={formData.company}
                onChange={handeChange}
              />
            </div>
          </div>
          <div className="sm:col-span-2">
            <label htmlFor="email" className="block text-sm font-semibold leading-6 text-zinc-400">
              Email
            </label>
            <div className="mt-2.5">
              <input
                type="email"
                name="email"
                id="email"
                autoComplete="email"
                placeholder="Your email address"
                required
                className="block w-full rounded-md border-0 px-3.5 py-2 shadow-sm ring-1 ring-inset bg-transparent ring-indigo-300 placeholder:text-zinc-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                value={formData.email}
                onChange={handeChange}
              />
            </div>
          </div>
          <div className="sm:col-span-2">
            <label htmlFor="message" className="block text-sm font-semibold leading-6 text-zinc-400">
              Message
            </label>
            <div className="mt-2.5">
              <textarea
                name="message"
                id="message"
                rows={4}
                placeholder="Tell us about your project"
                required
                className="block w-full rounded-md border-0 px-3.5 py-2 shadow-sm ring-1 ring-inset bg-transparent ring-indigo-300 placeholder:text-zinc-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                value={formData.message}
                onChange={handeChange}
              />
            </div>
          </div>
        </div>
        <div className="mt-10">
          <button
            type="submit"
            className="block w-full rounded-md bg-indigo-600 px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Let's talk
          </button>
        </div>
      </form>
    </div>

    )
}

export default Contact;